import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type PlaceOfAssessmentInputFields = {
  placeOfAssessment: string;
};

const PlaceOfAssessmentInput = ({
  placeOfAssessmentFieldConfig,
}: {
  placeOfAssessmentFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<PlaceOfAssessmentInputFields>();

  return (
    <InputField
      type="text"
      {...register("placeOfAssessment", {
        required: {
          value:
            placeOfAssessmentFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange plats för bedömning`,
        },
      })}
      label={t`Plats för bedömning`}
      showOptionalLabel={
        placeOfAssessmentFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.placeOfAssessment?.message}
    />
  );
};

export default PlaceOfAssessmentInput;
